import React, { useEffect, useState } from "react";
import "./header.scss";

const Header = ({ onScrollToBanner, onScrollToTechnology, onScrollToServices, onScrollToContact }) => {
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`website-header ${sticky ? "sticky" : ""}`}>
      <div className="logo-container">
        <img className="logo-container__logo" src={"/header-images/logo.png"} alt="logo"></img>
      </div>
      <div className="menu-container">
        <span className="menu-container__menu" onClick={onScrollToBanner}>Home</span>
        <span className="menu-container__menu" onClick={onScrollToServices}>Services</span>
        <span className="menu-container__menu" onClick={onScrollToTechnology}>About Us</span>
        <span className="menu-container__menu" onClick={onScrollToContact}>Contacts Us</span>
      </div>
      <div className="contact-container">
        <div className="contact-container__phone">
          <img alt="header" className="contact-container__phone__phone-img" src={"/header-images/phone-icon.png"}></img>
          <a className="contact-container__phone__link" href="tel:+917339437623">+917339437623</a>
        </div>
        <div className="contact-container__email">
          <img alt="header-mail" className="contact-container__email__email-img" src={"/header-images/email-icon.png"}></img>
          <a className="contact-container__email__link" href="mailto:techbloobind@gmail.com">techbloobind@gmail.com</a>
        </div>
      </div>
    </div>
  )

}

export default Header;
